import { Box } from "@mui/material";
import { FLOW_HUB_LAYOUT_CONFIG } from "../../../../config/flowhub.config";
import { flowHubCarouselConfig } from "./config/flowHubCarousel.config";
import { FlowHubCarouselItem } from "./components/FlowHubCarouselItem";
import { FlowHubCarouselControls } from "./components/FlowHubCarouselControls";
import { colorsConfig } from "../../../../../../config/colors.config";
import { useFlowHubCarouselControls } from "./hooks/useFlowHubCarouselControls";

export const FlowHubCarousel = () => {
  const slides = flowHubCarouselConfig();
  const { currentIndex, handleNext, handlePrevious, goToSlide } = useFlowHubCarouselControls(slides.length);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "1000px", xl: "1280px" },
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: { xs: "center", xl: "stretch" },
        flex: { xs: "0 0 auto", xl: 1 },
        height: { xs: "fit-content", xl: "auto" },
        minHeight: { xs: "auto", xl: 0 },
        px: { xs: 0, xl: 2 },
        pb: { xs: 0, xl: 3 },
      }}
    >
      <Box
        sx={{
          ...FLOW_HUB_LAYOUT_CONFIG,
          borderRadius: "3px",
          backgroundColor: colorsConfig.cardBg,
          width: "100%",
          height: { xs: "fit-content", xl: "auto" },
          minHeight: { xs: "auto", xl: "100%" },

          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 0,
        }}
      >
        {slides.map((item, index) => index === currentIndex && <FlowHubCarouselItem key={index} item={item} />)}

        <FlowHubCarouselControls
          totalSlides={slides.length}
          currentIndex={currentIndex}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          goToSlide={goToSlide}
        />
      </Box>
    </Box>
  );
};
